(function () {
  // Shift + mouse-wheel steps any carousel on the site one slide forward/back.
  //
  // Two carousel families exist on this theme and are handled separately:
  //   1. Swiper carousels (.swiper) — the theme's own carousels.
  //   2. The "GSC Instafeed" app widget (.gfa-content) — a third-party carousel
  //      with no Swiper instance, driven instead through its own arrow buttons.
  //
  // Both are made smooth the same way: by triggering the carousel's OWN animated
  // navigation (Swiper's slideNext/Prev, or GSC's arrow click) so each library
  // applies its own eased transition rather than teleporting the track.

  // --- Swiper ---------------------------------------------------------------
  // Every Swiper — freeMode or not — is driven through slideNext()/slidePrev()
  // so Swiper applies its own transition (params.speed, typically 300ms) and the
  // movement EASES instead of teleporting. This is the same code path the PDP
  // thumbnail gallery uses, which is why that one already feels smooth. (The old
  // freeMode branch called setTranslate() with no transition, so it jumped.)
  //
  // A controlled/synced swiper (allowTouchMove:false) cannot scroll itself, but
  // it may forward the gesture to a "driver" swiper via data-shift-scroll-target
  // (a CSS selector resolved within the nearest [data-shift-scroll-scope], or the
  // document if no scope is declared). This is what lets shift+wheel over a
  // testimonial's image/heading drive its text swiper.
  function resolveSwiper(swiperEl) {
    var swiper = swiperEl.swiper;
    if (!swiper || swiper.destroyed) return null;

    if (swiper.params.allowTouchMove === false) {
      var sel = swiperEl.getAttribute('data-shift-scroll-target');
      if (!sel) return null;
      var scope = swiperEl.closest('[data-shift-scroll-scope]') || document;
      var driverEl = scope.querySelector(sel);
      var driver = driverEl && driverEl.swiper;
      if (!driver || driver.destroyed || driver.params.allowTouchMove === false) return null;
      return driver;
    }

    return swiper;
  }

  function handleSwiper(e, swiperEl) {
    var swiper = resolveSwiper(swiperEl);
    if (!swiper) return;

    e.preventDefault();

    // One gesture = one eased step. While a transition is mid-flight, swallow
    // further wheel events so a single notch (or a trackpad's event burst) can't
    // fling past several slides on a long carousel like Bestsellers.
    if (swiper.animating) return;

    // Holding Shift maps vertical wheel to deltaX in some browsers and keeps it
    // on deltaY in others — only the sign matters here, so accept either axis.
    var delta = e.deltaY || e.deltaX;
    if (delta > 0) {
      swiper.slideNext();
    } else if (delta < 0) {
      swiper.slidePrev();
    }
  }

  // --- GSC Instafeed (gfa-*) ------------------------------------------------
  // The GetSiteControl Instagram-feed app renders its own carousel (no Swiper):
  // .gfa-content > .gfa-carousel__viewport > [transformed track], with prev/next
  // controls .gfa-arrow-left / .gfa-arrow-right. The app exposes no wheel-scroll
  // setting, so we synthesize a click on its arrow — reusing the widget's native
  // eased animation, autoplay handling and end-of-track logic instead of poking
  // its internal transform (which would be brittle and janky).
  function handleGsc(e, gscEl) {
    var widget = gscEl.closest('.gfa-content') || gscEl;

    var delta = e.deltaY || e.deltaX;
    if (!delta) return;

    var arrow = widget.querySelector(delta > 0 ? '.gfa-arrow-right' : '.gfa-arrow-left');
    // The widget marks a usable arrow with --visible and drops that class at the
    // track ends (it does not loop). If the arrow is missing (too few posts) or
    // unavailable in this direction, do nothing and let the page scroll — so the
    // gesture isn't trapped at the start/end of the feed.
    if (!arrow ||
        arrow.disabled ||
        arrow.getAttribute('aria-disabled') === 'true' ||
        !arrow.classList.contains('gfa-arrow-button--visible')) return;

    e.preventDefault();

    // Collapse a wheel burst into a single step: ignore further events until this
    // step's transition finishes. Read the duration off the track so the lock
    // self-tunes to whatever the widget is configured to use.
    var now = e.timeStamp || 0;
    if (widget.__gscLockUntil && now < widget.__gscLockUntil) return;

    var viewport = widget.querySelector('.gfa-carousel__viewport');
    var track = viewport && viewport.children[0];
    var durMs = 350;
    if (track) {
      var d = parseFloat(getComputedStyle(track).transitionDuration);
      if (d) durMs = d * 1000;
    }
    widget.__gscLockUntil = now + durMs;

    arrow.click();
  }

  document.addEventListener('wheel', function (e) {
    if (!e.shiftKey) return;

    var swiperEl = e.target.closest('.swiper');
    if (swiperEl) {
      handleSwiper(e, swiperEl);
      return;
    }

    var gscEl = e.target.closest('.gfa-content, .gfa-carousel__viewport');
    if (gscEl) {
      handleGsc(e, gscEl);
    }
  }, { passive: false });
})();
